import MVPPage from './MVPPage';
export default MVPPage;
